// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"wallet-manage-purchase-card-modal-select-design_skeleton__1_liM"};